// Gastos (7.3h): publicidad, nómina, transporte, plataformas… Las compras de material van en Inventario.
import type { SupabaseClient } from '@supabase/supabase-js';
import type { Moneda } from '../logica/dinero';
import { todas } from './pedidos';

// valor está en la moneda del gasto (COP o USD); tasa_cop son los pesos por 1 unidad de esa moneda, congelada al registrar (1 si es COP).
export interface Gasto { id: number; fecha: string; categoria_id: number; descripcion: string | null; valor: number; moneda: Moneda; tasa_cop: number }
type Fila = Omit<Gasto, 'valor' | 'moneda' | 'tasa_cop'> & { valor: number | string; moneda?: string | null; tasa_cop?: number | string | null };
const ok = ({ error }: { error: { message: string } | null }) => { if (error) throw new Error(/duplicate key|unique/i.test(error.message) ? 'Ya existe una categoría con ese nombre.' : error.message); };

// Se piden todas las columnas (y no una lista) para que la app también funcione si la base todavía no tiene moneda y tasa: esos gastos se leen en pesos.
export async function cargarGastos(sb: SupabaseClient): Promise<Gasto[]> {
  const filas = await todas<Fila>((a, b) => sb.from('gastos').select('*').order('fecha', { ascending: false }).order('id', { ascending: false }).range(a, b));
  return filas.map(g => ({ id: g.id, fecha: g.fecha, categoria_id: g.categoria_id, descripcion: g.descripcion, valor: +g.valor,
    moneda: (g.moneda ? String(g.moneda).trim() : 'COP') as Moneda, tasa_cop: +(g.tasa_cop ?? 1) || 1 }));
}
// En pesos no se envían moneda ni tasa (la base pone COP y 1): así registrar en pesos sigue funcionando aunque la base aún no tenga esas columnas.
export async function registrarGasto(sb: SupabaseClient, g: Omit<Gasto, 'id'>) {
  const { moneda, tasa_cop, ...base } = g;
  const fila: Record<string, unknown> = moneda === 'COP' ? base : { ...base, moneda, tasa_cop };
  ok(await sb.from('gastos').insert(fila));
}
export async function borrarGasto(sb: SupabaseClient, id: number) { ok(await sb.from('gastos').delete().eq('id', id)); }
export async function crearCategoriaGasto(sb: SupabaseClient, nombre: string): Promise<number> {
  const { data, error } = await sb.from('categorias').insert({ ambito: 'gasto', nombre }).select('id').single();
  ok({ error });
  return data!.id as number;
}
